<template>
    <div class="bubble-chart" >
        <div id="popup" style="display: none;" v-tippy-html>
            <div v-if="hoveredNode" class="popover-content">
                <h3>{{hoveredNode.data['nombre_'+dimensions.ordinal[0]]}}</h3>
                <h4>Presupuesto ejecutado</h4>
                <div class="amount">{{moneyFormatter(hoveredNode.value)}}</div>
                <div class="percentage">{{numeral(hoveredNode.data.percentage).format('0.00%')}} del ppto total</div>
            </div>
        </div>
        <svg :width="width" :height="height" :viewBox="'0 0 '+width+' '+height">
            <g v-for="d in children" class="node" :transform="'translate('+d.x+','+d.y+')'" @click="detailClicked(d)" @mouseenter="hoveredNode = d" v-tippy="{html: '#popup', followCursor: true, arrow: true, animation: 'fade'}">
                <circle :r="d.r" :fill="color(d.data[dimensions.ordinal[0]])"></circle>
                <foreignObject :x="-d.r" :y="-d.r" :width="2 * d.r" :height="2 * d.r" :key="d.data[dimensions.ordinal[0]]">
                    <body>
                        <div class="content">
                            <div v-if="d.r > 50" class="text">
                                <div class="name">{{d.data['nombre_'+dimensions.ordinal[0]]}}</div>
                                <div class="size">{{numeral(d.data.percentage).format('0.00%')}}</div>
                            </div>
                        </div>

                    </body>
                </foreignObject>
            </g>
        </svg>
    </div>

</template>
<style lang="scss">
    .bubble-chart{
        svg{
            width: 100%;
            height: auto;
            .node{
                transition: all 1s ease;
                circle{
                    transition: all 1s ease;
                }
            }
            foreignObject{
                cursor: pointer;
                body{
                    width: 100%;
                    height: 100%;
                    background: transparent;

                    .content{
                        width: 100%;
                        height: 100%;
                        //display: table;
                        .text{
                            width: 100%;
                            height: 100%;
                            text-align: center;
                            color: white;
                            //display: table-cell;
                            //vertical-align: middle;
                            padding: 20px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            .name{
                                font-size: 100%;
                                margin-bottom: 5px;
                            }
                            .size{
                                font-size: 175%;
                            }
                        }
                    }
                }
            }
        }

    }
</style>
<script>
    import * as d3 from 'd3';
    import _ from 'lodash';
    import numeral from 'numeral';
    import moneyFormatter from '../../Methods/MoneyFormatter';
    import textFit from 'textfit';

    export default{
        data: function(){
            return {
                hoveredNode: null
            }
        },
        props: {
            data: {},
            width: {default: 1110},
            height: {default: 1110},
            dimensions: {},
        },
        methods:{
            numeral: numeral,
            moneyFormatter: moneyFormatter,
            detailClicked: function(n){
                this.$emit('detail-clicked', n.data)
            },
        },
        watch:{
            children: function(){
                this.$nextTick(()=>{
                    textFit(this.$el.querySelectorAll('foreignObject body .content .text'),{
                        minFontSize: 6,
                        maxFontSize: 16
                    });
                })
            }
        },
        computed:{
            color: function(){
                return d3.scaleOrdinal(['' + '#253494', '#3455DB', '#1E90FF', '#081D58', '#28A228']);
            },
            pack: function () {
                return d3.pack()
                    .size([this.width, this.height])
                    .padding(3);
            },
            children: function(){
                return this.pack(this.root).children;
            },
            root: function(){
                return d3.hierarchy({children: this.data})
                    .sum(function(d) { return d.sum; })
                    /*
                    .each(function(d) {
                        if (id = d.data.id) {
                            var id, i = id.lastIndexOf(".");
                            d.id = id;
                            d.package = id.slice(0, i);
                            d.class = id.slice(i + 1);
                        }
                    });
                    */
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Charts/Bubble.vue